<template>
    <div class="bg-white p-5 pb-1 pt-4 mt-4 rounded">
        <h4 class="title-primary">Nuevos colaboradores</h4>

        <div class="bg-utel-v2-secondary p-5 mb-2 mt-3 pt-4 rounded" id="agregar_estudiante">
            <h4 class="title-secondary">Agregar colaborador</h4>
            <small>Completa el formulario para agregar un nuevo colaborador</small>
            
            <form @submit.prevent="agregarUsuario" class="mt-4">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <!-- Empresa Selection -->
                        <div v-if="empresas.length > 0" class="form-group mb-4">
                            <label for="empresa" class="form-label">Seleccione una empresa</label>
                            <select v-model="url" class="form-control rounded-8 sin-borde py-2" required>
                                <option value="">Seleccionar la empresa</option>
                                <option v-for="client in empresas" :key="client.id" :value="client.non_massive_">
                                    {{ client.client }}
                                </option>
                            </select>
                        </div>

                        <!-- Form Fields -->
                        <div class="form-group mb-4">
                            <input 
                                v-model="newUser.firstname" 
                                type="text" 
                                class="form-control rounded-8 sin-borde"
                                :class="{ 'is-invalid': validation.firstname.error }"
                                placeholder="Nombre del Usuario" 
                                required
                            />
                            <div v-if="validation.firstname.error" class="invalid-feedback">
                                {{ validation.firstname.message }}
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <input 
                                v-model="newUser.lastname" 
                                type="text" 
                                class="form-control rounded-8 sin-borde"
                                :class="{ 'is-invalid': validation.lastname.error }"
                                placeholder="Apellido del usuario" 
                                required
                            />
                            <div v-if="validation.lastname.error" class="invalid-feedback">
                                {{ validation.lastname.message }}
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <input 
                                v-model="newUser.email" 
                                type="email" 
                                class="form-control rounded-8 sin-borde"
                                :class="{ 'is-invalid': validation.email.error }"
                                placeholder="Email de usuario" 
                                @blur="validateEmail"
                                required
                            />
                            <div v-if="validation.email.error" class="invalid-feedback">
                                {{ validation.email.message }}
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <input 
                                v-model="newUser.position" 
                                type="text" 
                                class="form-control rounded-8 sin-borde"
                                placeholder="Cargo" 
                            />
                        </div>

                        <div class="form-group mb-4 position-relative">
                            <input 
                                v-model="newUser.area" 
                                type="text" 
                                class="form-control rounded-8 sin-borde"
                                placeholder="Área" 
                                @input="searchAreas"
                                @blur="hideAreasList"
                            />
                            <ul v-if="showAreas && filteredAreas.length" class="autocomplete-list">
                                <li v-for="area in filteredAreas" :key="area" @mousedown="selectArea(area)">
                                    {{ area }}
                                </li>
                            </ul>
                        </div>

                        <div class="form-group mb-4">
                            <input 
                                v-model="newUser.level" 
                                type="text" 
                                class="form-control rounded-8 sin-borde"
                                placeholder="Nivel" 
                            />
                        </div>

                        <div class="form-group mb-4">
                            <input 
                                ref="phoneInput"
                                v-model="newUser.cellphone" 
                                type="tel" 
                                class="form-control rounded-8 sin-borde"
                                :class="{ 'is-invalid': validation.cellphone.error }"
                                placeholder="Celular"
                                @input="validatePhone"
                            />
                            <div v-if="validation.cellphone.error" class="invalid-feedback">
                                {{ validation.cellphone.message }}
                            </div>
                        </div>

                        <div class="d-flex gap-3 justify-content-end">
                            <button type="button" @click="resetForm" class="btn bg-utel-v2-secondary text-primary rounded-8">
                                Cancelar
                            </button>
                            <button type="submit" :disabled="!isFormValid || isSubmitting" class="btn btn-primary rounded-8">
                                {{ isSubmitting ? 'Procesando...' : 'Guardar colaborador' }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Bulk Upload Section -->
        <div class="bg-utel-v2-secondary p-5 mb-2 mt-3 pt-4 rounded" id="carga_masiva_estudiante">
            <h4 class="title-secondary">Carga masiva de colaboradores</h4>
            <div class="row">
                <div class="col-md-6">
                    <small>Puedes cargar una lista de colaboradores desde un archivo de carga masiva...</small>
                    
                    <div v-if="empresas.length > 0" class="mt-4">
                        <select v-model="urlMassive" class="form-control rounded-8 sin-borde py-2">
                            <option value="">Seleccionar empresa para la carga masiva</option>
                            <option v-for="client in empresas" :key="client.id" :value="client.url">
                                {{ client.client }}
                            </option>
                        </select>
                    </div>
                    
                    <div class="mt-3">
                        <a href="/templates/template_carga_de_usuarios_masivos.csv" download target="_blank" class="text-decoration-underline">
                            Descargar plantilla
                        </a>
                    </div>
                </div>
                
                <div class="col-md-6 d-flex flex-column align-items-end justify-content-center">
                    <small v-if="selectedFile" class="mb-3">{{ selectedFile.name }}</small>
                    <v-btn class="bg-utel" rounded dark :loading="isUploading" @click="handleFileImport">
                        Subir archivo .csv
                    </v-btn>
                    <input ref="uploader" type="file" accept=".csv" @change="onFileChanged" class="d-none">
                </div>
            </div>
        </div>

        <!-- Modals -->
        <modal-after-create-component :usuario="lastUser" :tipousuario="'student'"></modal-after-create-component>
        <modal-info-commom-component v-if="showModalInfo" :info="message" @close="closeModalInfo"></modal-info-commom-component>
    </div>
</template>

<script>
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_MIN_LENGTH = 9;

export default {
    props: {
        get: String,
        headertab: Array,
        rol: Array,
        empresas: { type: Array, default: () => [] },
        searcharea: String,
        searchnivel: String,
        urlvalidateemail: String,
        listroutes: Array,
        urlmassive: String
    },
    
    data() {
        return {
            url: this.get,
            lastUser: this.getEmptyUser(),
            newUser: this.getEmptyUser(),
            filteredAreas: [],
            showAreas: false,
            phoneIti: null,
            isSubmitting: false,
            isUploading: false,
            selectedFile: null,
            urlMassive: this.empresas.length > 0 ? '' : this.urlmassive,
            message: { title: '', content: '' },
            showModalInfo: false,
            validation: {
                firstname: { error: false, message: '' },
                lastname: { error: false, message: '' },
                email: { error: false, message: '' },
                cellphone: { error: false, message: '' }
            }
        };
    },
    
    computed: {
        isFormValid() {
            return this.newUser.firstname && 
                   this.newUser.lastname && 
                   this.newUser.email && 
                   EMAIL_REGEX.test(this.newUser.email) &&
                   this.newUser.cellphone &&
                   this.newUser.cellphone.length >= PHONE_MIN_LENGTH &&
                   this.url;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initPhone();
        });
    },
    
    methods: {
        getEmptyUser() {
            return {
                firstname: '',
                lastname: '',
                email: '',
                cellphone: '',
                level: '',
                position: '',
                area: '',
                role: 'Estudiante'
            };
        },
        
        async agregarUsuario() {
            if (!this.isFormValid || this.isSubmitting) return;
            
            this.isSubmitting = true;
            this.lastUser = { ...this.newUser };
            
            try {
                const userData = { 
                    ...this.newUser,
                    cellphone: this.phoneIti ? this.phoneIti.getNumber() : this.newUser.cellphone
                };
                
                const response = await axios.post(this.url, userData);
                
                this.$swal('Se ha creado el colaborador.');
                this.$emit('reload_table', true);
                this.resetForm();
                
                const successBtn = document.getElementById('studentsuccesCreationBtn');
                if (successBtn) successBtn.click();
                
            } catch (error) {
                const errors = error.response?.data?.errors || {};
                this.handleValidationErrors(errors);
                this.$swal('Hubo un error al crear el colaborador.');
            } finally {
                this.isSubmitting = false;
            }
        },
        
        handleValidationErrors(errors) {
            Object.keys(this.validation).forEach(field => {
                this.validation[field] = {
                    error: !!errors[field],
                    message: errors[field] ? errors[field][0] : ''
                };
            });
        },
        async searchAreas() {
            const query = this.newUser.area;
            if (query.length >= 3) {
                try {
                    const response = await axios.post(this.searcharea, { query });
                    this.filteredAreas = response.data.map(item => item.area.trim());
                    this.showAreas = true;
                } catch (error) {
                    console.error('Error searching areas:', error);
                    this.filteredAreas = [];
                }
            } else {
                this.filteredAreas = [];
                this.showAreas = false;
            }
        },
        
        selectArea(area) {
            this.newUser.area = area;
            this.showAreas = false;
            this.filteredAreas = [];
        },
        
        hideAreasList() {
            setTimeout(() => {
                this.showAreas = false;
            }, 200);
        },
        async validateEmail() {
            const email = this.newUser.email;
            
            if (!email) {
                this.validation.email = { error: true, message: 'El email es requerido' };
                return;
            }
            
            if (!EMAIL_REGEX.test(email)) {
                this.validation.email = { error: true, message: 'El formato del email no es válido' };
                return;
            }
            
            try {
                const response = await axios.post(this.urlvalidateemail, { email });
                if (!response.data) {
                    this.validation.email = { error: true, message: 'El email ya está registrado' };
                    this.$swal('El email registrado ya existe');
                } else {
                    this.validation.email = { error: false, message: '' };
                }
            } catch (error) {
                console.error('Error validating email:', error);
            }
        },
        
        validatePhone() {
            const phone = this.newUser.cellphone;
            if (phone.length < PHONE_MIN_LENGTH) {
                this.validation.cellphone = { 
                    error: true, 
                    message: `El número debe tener al menos ${PHONE_MIN_LENGTH} dígitos` 
                };
            } else {
                this.validation.cellphone = { error: false, message: '' };
            }
        },
        initPhone() {
            if (window.intlTelInput && this.$refs.phoneInput) {
                this.phoneIti = window.intlTelInput(this.$refs.phoneInput, {
                    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
                    initialCountry: 'mx',
                    separateDialCode: true,
                    hiddenInput: 'full'
                });
            }
        },
        handleFileImport() {
            this.isUploading = true;
            window.addEventListener('focus', () => {
                this.isUploading = false;
            }, { once: true });
            this.$refs.uploader.click();
        },
        onFileChanged(e) {
            this.selectedFile = e.target.files[0];
            if (this.selectedFile) {
                this.submitFiles();
            }
        },
        
        async submitFiles() {
            if (!this.urlMassive) {
                this.showMessage('Advertencia!', 'Debe seleccionar una empresa para subir registros masivos.');
                return;
            }
            
            if (!this.selectedFile) return;
            
            this.isUploading = true;
            
            try {
                const formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('tipo', 'Estudiante');
                
                await axios.post(this.urlMassive, formData);
                this.showMessage('Proceso exitoso!', 'Se ha cargado la información de usuarios masivos correctamente.');
                this.$emit('reload_table', true);
            } catch (error) {
                this.showMessage('Error!', 'Hubo un error al procesar el archivo.');
                console.error('Upload error:', error);
            } finally {
                this.isUploading = false;
                this.selectedFile = null;
                this.$refs.uploader.value = '';
            }
        },
        
        showMessage(title, content) {
            this.message = { title, content };
            this.showModalInfo = true;
        },
        closeModalInfo() {
            this.showModalInfo = false;
        },
        
        resetForm() {
            this.newUser = this.getEmptyUser();
            Object.keys(this.validation).forEach(field => {
                this.validation[field] = { error: false, message: '' };
            });
        }
    }
};
</script>

<style scoped>
.title-primary {
    color: #1A0054;
    font-weight: bold;
}

.title-secondary {
    color: #494949;
    font-weight: bold;
}

.form-label {
    color: #1A0054;
    font-weight: 500;
}

.autocomplete-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    list-style: none;
    padding: 0;
    margin: 0;
}

.autocomplete-list li {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
}

.autocomplete-list li:hover {
    background-color: #f5f5f5;
}

.autocomplete-list li:last-child {
    border-bottom: none;
}

.iti {
    width: 100%;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
}
</style>
